require('./bootstrap');
require('node-waves');
require('../../recrmv1/js/admin');
require('../../recrmv1/js/login');
